function _replacer(translation, searchValue, replaceValue) {
  return translation.replace(`{{${searchValue}}}`, replaceValue);
}
export async function fetchTranslations(translatedValues, key) {
  const i18nWebStorageLocaleKey = `${key}`;
  let translations = {};
  const existingTranslations: any = JSON.parse(sessionStorage.getItem(i18nWebStorageLocaleKey) || '{}');
  if (existingTranslations && Object.keys(existingTranslations).length > 0) {
    translations = existingTranslations;
  } else {
    try {
      const data = translatedValues;
      const translationStrings = data;
      sessionStorage.setItem(i18nWebStorageLocaleKey, JSON.stringify(translationStrings));
      translations = translationStrings;
      if (window['AIBA'] && window['AIBA']['utils']) {
        const handlers = window['AIBA']['utils'];
        await handlers.seti18nData(translations);
      }
    } catch (exception) {
      translations = {};
      console.error(`Error loading locale: `, exception);
    }
  }
}

export async function getTranslation(translationKey, replacer = null) {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const translations = await handlers.geti18nData();

    if (translations[translationKey]) {
      let translationString = translations[translationKey];

      if (replacer) {
        for (const [key, value] of Object.entries(replacer)) {
          translationString = _replacer(translationString, key, value);
        }
      }

      return translationString;
    } else {
      return null;
    }
  }
}

const i18n = {
  fetchTranslations,
  getTranslation,
};

export default i18n;
